import { createSlice, PayloadAction } from "@reduxjs/toolkit";
import { AuthenticateState } from "../../types/types";

type Auth = {
  authenticateStatus: AuthenticateState;
  loggedIn: boolean;
  currentAddress: string;
  currentDomain: string;
  engagementPoint: number;
  isInvited: boolean;
  easterEggAvailability: boolean;
};

const initialState: Auth = {
  authenticateStatus: AuthenticateState.PENDING,
  loggedIn: false,
  currentAddress: "",
  currentDomain: "",
  engagementPoint: 0, // The engagement points based on the user's engagement
  isInvited: false,
  easterEggAvailability: false,
};

export const authSlice = createSlice({
  name: "auth",
  initialState,
  reducers: {
    setCurrentAddress: (state, action: PayloadAction<string>) => {
      state.currentAddress = action.payload;
    },
    setCurrentDomain: (state, action: PayloadAction<string>) => {
      state.currentDomain = action.payload;
    },
    setEngagementPoint: (state, action: PayloadAction<number>) => {
      state.engagementPoint = action.payload;
    },
    setAuthenticateStatus: (
      state,
      action: PayloadAction<AuthenticateState>
    ) => {
      state.authenticateStatus = action.payload;
    },
    setEasterEggAvailability: (state, action: PayloadAction<boolean>) => {
      state.easterEggAvailability = action.payload;
    },
    setIsInvited: (state, action: PayloadAction<boolean>) => {
      state.isInvited = action.payload;
    },
  },
});

// Action creators are generated for each case reducer function
export const {
  setCurrentAddress,
  setCurrentDomain,
  setEngagementPoint,
  setIsInvited,
  setAuthenticateStatus,
  setEasterEggAvailability,
} = authSlice.actions;

export default authSlice.reducer;
